export const LOGO_URL =
  "https://customer-assets.emergentagent.com/job_peptide-pro-6/artifacts/198z0l28_ChatGPT%20Image%20Apr%2028%2C%202026%2C%2001_46_32%20PM.png";

export const BRAND = {
  name: "ProSource Labs",
  short: "PSL",
  tagline: "Precision. Purity. Performance.",
};
